



























import {
  deleteServiceTaskDefault,
  ServiceTaskDefault
} from "@/api/project/service-task-default-api";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 現場のプロパティキーのテーブル
 */
@Component({})
export default class ServiceTaskDefaultTable extends Vue {
  @Prop({ required: true }) items!: ServiceTaskDefault[];

  fields = [
    { key: "name", label: "タスク" },
    { key: "value", label: "デフォルト日数" },
    { key: "actions", label: "" }
  ];

  async deleteItem(id: string) {
    if (!confirm("この項目を削除してもよろしいですか？")) {
      return;
    }
    await deleteServiceTaskDefault(id);
    this.$emit("remove", id);
  }
}
